var React = require('react');

function GreyFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.25 0H1.75C0.786133 0 0 0.786133 0 1.75V12.25C0 13.2139 0.786133 14 1.75 14H7V9.1875H5.25V7H7V5.25C7 3.80078 8.17578 2.625 9.625 2.625H11.375V4.8125H10.5C10.0181 4.8125 9.625 4.76807 9.625 5.25V7H11.8125L10.9375 9.1875H9.625V14H12.25C13.2139 14 14 13.2139 14 12.25V1.75C14 0.786133 13.2139 0 12.25 0Z","fill":"#9A9A9A"}));
}

GreyFacebookInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = GreyFacebookInline;

GreyFacebookInline.default = GreyFacebookInline;
